import { useState } from "react";
import { notification } from "antd";
import { useMsal } from "@azure/msal-react";

import { BookedForSalesApiClient } from "../../../providers/api-provider";

export const useAcceptanceBookedForSales = () => {
	const { instance } = useMsal();

	const [acceptBookedForSalesLoading, setAcceptBookedForSalesLoading] = useState<boolean>(false);
	const [cancelBookedForSalesLoading, setcancelBookedForSalesLoading] = useState<boolean>(false);

	const handleConfirmModal = async (
		bookedForSalesId: number,
		acceptBookedForSales: {
			customerFacilityId: number;
			poNumber: string;
			note?: string;
			sendToSap: boolean;
		},
		onOk: () => void,
		onAccept: () => void
	) => {
		const clientApi = await BookedForSalesApiClient(instance);

		setAcceptBookedForSalesLoading(true);

		clientApi.acceptBookedForSales(bookedForSalesId, acceptBookedForSales)
			.then((response) => {
				setAcceptBookedForSalesLoading(false);

				notification.success({
					message: "Customer order confirmed!",
					description: "Customer order confirmed.",
					duration: 2
				});
				onOk();
				onAccept();
			})
			.catch((error) => {
				setAcceptBookedForSalesLoading(false);

				notification.error({
					message: "Unable to accept this customer order!",
					description: "Unable to accept this customer order.",
					duration: 2
				});
			});
	};

	const handleCancelModal = async (
		bookedForSalesId: number,
		cancelBookedForSales: { reasonWhyCancel: string; note?: string },
		onOk: () => void,
		onAccept: () => void
	) => {
		const clientApi = await BookedForSalesApiClient(instance);

		setcancelBookedForSalesLoading(true);

		clientApi.cancelBookedForSales(bookedForSalesId, cancelBookedForSales)
			.then((response) => {
				setcancelBookedForSalesLoading(false);

				notification.success({
					message: "Customer order cancelled!",
					description: "Customer order cancelled.",
					duration: 2
				});
				onOk();
				onAccept();
			})
			.catch((error) => {
				setcancelBookedForSalesLoading(false);

				notification.error({
					message: "Unable to cancel this customer order!",
					description: "Unable to cancel this customer order.",
					duration: 2
				});
			});
	};

	return {
		handleConfirmModal,
		acceptBookedForSalesLoading,
		handleCancelModal,
		cancelBookedForSalesLoading
	};
};